import React from 'react';
import { useAtom } from 'jotai';

import { DrawerCustom } from './DrawerCustom';
import { subDrawerState } from '@esg/framework';

export const SubDrawer = () => {
    const [drawerState, setDrawerState] = useAtom(subDrawerState);
    const resetDrawerState = () => setDrawerState(subDrawerState.init);

    return (
        <DrawerCustom
            onClose={resetDrawerState}
            open={drawerState?.isOpen}
            drawerTitle={drawerState?.titleTransCode}
            drawerSubtitle={drawerState?.subtitle}
            footer={drawerState?.footer}
        >
            {drawerState?.content}
        </DrawerCustom>
    );
};
